<!--
 * @Author: Nie Wei
 * @Date: 2020-01-14 16:13:49
 * @Last Modified by:   Nie Wei
 * @Last Modified time: 2020-01-14 16:13:49
 -->
<template>
  <Page></Page>
</template>

<script>
import Page from '@/views'

export default {
  components: {
    Page,
  },
  mounted() {
    document.getElementsByTagName('meta').viewport.content = `width=device-width,initial-scale=${document.body.clientWidth / 750}`
  },
}
</script>

<style lang="scss">
</style>
